import styled from 'styled-components';

import BG from '@assets/images/skinplace/Gradient.webp';

export const Wrapper = styled.div`
	max-width: 418px;
	width: 100%;
	padding: 12px;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	background-image: url(${BG});
	background-position: right;
	background-size: cover;

	display: flex;
	align-items: center;
	gap: 8px;

	@media (max-width: 992px) {
		max-width: 100%;
		width: 100%;
	}
`;

export const IconWrapper = styled.div`
	width: 86px;
	height: 86px;
	min-width: 86px;
	min-height: 86px;
	img {
		width: 100%;
		height: 100%;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const Step = styled.p`
	margin: 0;
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const Text = styled.p`
	margin: 0;
	font-size: 16px;
	line-height: 22px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
`;
